import React, { Fragment, useEffect, useState } from "react";
import { Form, Row, Col, Button } from "reactstrap";
import "./index.css";
import { useFormik } from "formik";
import { AssignToOption, formikTasksFromActivity } from "./constant";
import TextInput from "../../components/InputFields/TextInput";
import DatePickerSelector from "../../components/InputFields/DatePicker";
import moment from "moment";
import { taskActionOptions } from "../applications/Constant";
import { useDispatch, useSelector } from "react-redux";
import { getPatients } from "../../api/patient";
import { decryptData } from "../../utils/helper";
import { decryptPatientData } from "../../utils/common";
import { failed, success } from "../../utils/Tostify";
import { getStaffsByOrgId } from "../../api/User";
import { addTask, createApplicationActivity, getAllApplication, getPendingTasks } from "../../api/Applications";
import { ActivityDetails } from "../../utils/constants";
import Loader from "../../components/Loader/Loader";

//This component is used in Actions and Activity
const Tasks = ({ setOpenTaskForm ,AllTasks,PendingTasks,onTaskCreated}) => {
  const dispatch = useDispatch();
  let token = useSelector((state) => state.userReducer.token);
  const [patients, setPatients] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [applicationList, setApplicationList] = useState([]);
  const [applicationFilteredList, setApplicationFilteredList] = useState([]);
  const [assignToList, setAssignToList] = useState([]);
  const [selectedApplication, setSelectedApplication] = useState([]);
  const [patientOptions, setPatientOptions] = useState([]);
  const [assignToOptions, setAssignToOptions] = useState(AssignToOption);
  let user = useSelector((state) => state?.userReducer?.user);

  const formik = useFormik({
    ...formikTasksFromActivity,
    onSubmit: async (values) => {
      let res;
      try {
        setIsLoading(true); // Set loading state before API call
        // Ensure correct `assignTo` value based on `assignee`
        const payload = {
          tasks: {
            ...values,
            editedBy: user?._id,
            assignTo: values.assignee === "Patient" ? values.patientId : values.assignTo
          }
        };
        res = await addTask({ values: payload, dispatch, token, applicationId: formik.values.applicationId , userId: user._id});
        if (res?.status === "SUCCESS") {
          const createdAppId = formik.values.applicationId;
          const pendingRes = await getPendingTasks({ dispatch, token, clinicId: localStorage.getItem("currentHospitalId") });
          const decryptedPending = pendingRes?.data;
          // Find the application by matching _id
          const matchedApp = decryptedPending?.find(app => app._id === createdAppId);
          // Get the last task from that application
          const lastTask = matchedApp?.tasks?.[matchedApp.tasks.length - 1];
          // Trigger callback with the last task
          if (lastTask && typeof onTaskCreated === "function") {
            onTaskCreated(lastTask);
          }
          let activityValues = {
            type: "Application",
            event: ActivityDetails?.TaskCreationUpdate?.event,
            applicationId: formik.values.applicationId,
            clinicId: localStorage.getItem("currentHospitalId"),
            organizationId: localStorage.getItem("currentOrgId"),
            patientId: formik.values?.patientId,
            details: "Task Created"
          };
          await createApplicationActivity({ values: activityValues, dispatch, token });
          setOpenTaskForm();
          if (typeof PendingTasks === "function") {
            await PendingTasks();
          }
          if (typeof AllTasks === "function") {
          await AllTasks();
          }
          success(res?.message);
        } else {
          failed(res?.message || "Something went wrong");
        }
      } catch (error) {
        failed(error?.message || "Error occurred");
      } finally {
        setIsLoading(false); // Ensure loading state is always reset
      }
    }
  });


  const handleApplication = (e)=>{
    if((formik.values.patientId === "") || (formik.values.patientId === null)){
      failed("Please select patinet first.");
    }else{
      formik.setFieldValue("applicationId", e.target.value);
      setSelectedApplication(applicationFilteredList.find((app)=> app?._id === e.target.value));
    }
  };

  const handlePatient = (e)=>{
    formik.setFieldValue("patientId", e.target.value);
    setApplicationFilteredList(applicationList.filter((app)=> app?.patientData?._id === e.target.value));
  };

  const getPatientList = async () => {
    let res;
    try {
      res = await getPatients({ dispatch, token, orgId : localStorage.getItem("currentOrgId"), clinicId : localStorage.getItem("currentHospitalId") });
      if (res?.status === "SUCCESS") {
        const responseData = decryptData(res.data);
        if (responseData?.list) {
          const decryptedPatients = await Promise.all(
            responseData.list.map(async (patient) => {
              return decryptPatientData(patient);
            })
          );
          setPatients({ ...responseData, items: decryptedPatients});
        }
      }
    } catch (error) {
      failed(res?.message);
    }
  };

  const getStaffList = async (page, limit, searchKey = "") => {
    let res;
    try {
      res = await getStaffsByOrgId({dispatch, token, page, limit, searchKey, orgId: localStorage.getItem("currentOrgId"), currentHospitalId : localStorage.getItem("currentHospitalId"), dataLimit: "all"});
      const responseData = decryptData(res?.data);
      if (res?.status === "SUCCESS") {
        const dropdownData = responseData?.items?.map((staff) => ({
          label: `${staff.firstName} ${staff.lastName}`,
          value: staff._id
        }));
        setAssignToList(dropdownData);
      }
    } catch (error) {
      failed(res?.message);
    }
  };

  const getApplicationList = async () => {
    let res;
    try {
        res = await getAllApplication({
            dispatch,
            token,
            clinicId: localStorage.getItem("currentHospitalId")
        });

        if (res?.status === "SUCCESS") {
            const responseData = decryptData(res?.data);
            const filteredApplications = responseData?.list?.items.filter(
                (app) => app?.status === "InProcess" && !app?.isArchived // Adjust `isArchived` if different in your data
            );

            setApplicationList(filteredApplications);
        }
    } catch (error) {
        failed(res?.message || "Failed to fetch applications.");
    }
};

  useEffect(() => {
    getPatientList();
    getStaffList();
    getApplicationList();
  }, []);


  useEffect(() => {
    const fetchDecryptedPatients = async () => {
      const inProcessPatients = applicationList
        .filter((app) => app?.status === "InProcess")
        .map((app) => app?.patientData);
      const uniqueInProcessPatients = Array.from(
        new Map(inProcessPatients.map((p) => [p._id, p])).values()
      );
      // Decrypt patient data asynchronously
      const decryptedPatients = await Promise.all(
        uniqueInProcessPatients.map(async (patient) => {
          return await decryptPatientData(patient);
        })
      );
      // Update the dropdown options with decrypted data
      setPatientOptions(
        decryptedPatients.map((patient) => ({
          value: patient?._id,
          label: patient?.name?.text || "Unknown"
        }))
      );
    };

    fetchDecryptedPatients();
  }, [applicationList]);

  const handlePatientChange = (e) => {
    const selectedPatientId = e.target.value;
    const selectedPatient = patientOptions.find(p => p.value === selectedPatientId);
    if (selectedPatient) {
      const updatedAssignToOptions = [
        { label: `Patient - ${selectedPatient.label}`, value: "Patient" },
        { label: "Staff", value: "Staff" }
      ];
      setAssignToOptions(updatedAssignToOptions);
    }

    formik.setFieldValue("patientId", selectedPatientId);
  };

  const isDocumentListVisible = formik.values.taskAction === "Upload Document";
  const isFormListVisible = ["Update Form", "Sign Form", "Verify Form"].includes(formik.values.taskAction);

  const VerifyformOptions = selectedApplication?.applicationForms?.map((app) => ({
    label: app.formTitle,
    value: app._id
  })) || [];

  const UpdateformOptions = selectedApplication?.applicationForms
    ?.filter((app) => ["To Do", "InProgress"].includes(app.status?.trim())) // Filter by status
    ?.map((app) => ({
      label: app.formTitle,
      value: app._id
    })) || [];

  // Select the appropriate form options dynamically
  const selectedFormOptions =
    formik.values.taskAction === "Verify Form"
      ? VerifyformOptions
      : formik.values.taskAction === "Update Form"
      ? UpdateformOptions
      : [];

  return (
    <Fragment>
      {isLoading && <Loader/>}
      <div className="schedule_task mt-3">
        <div className="schedule_header"><h2 className="task_title">Schedule a Task</h2></div>
        <Form onSubmit={formik.handleSubmit} className="form_schedule patient_schedule">
        <Row>
            <Col lg={8}>
              <TextInput
                keyField={"title"}
                label="Title"
                required={true}
                formik={formik}
                type="text"
                value={formik.values.title}
                onChange={(e) =>
                  formik.setFieldValue("title", e.target.value)
                }
              />
            </Col>
            <Col lg={4}>
              <TextInput
                keyField={"patientId"}
                label="Patient"
                required={true}
                formik={formik}
                options={patientOptions}
                type="select"
                placeholder="Select"
                value={formik.values.patientId}
                // onChange={handlePatient}
                onChange={(e) => {
                  handlePatient(e);
                  handlePatientChange(e);
                }}
              />
            </Col>
            <Col lg={4}>
              <TextInput
                keyField={"applicationId"}
                label="Applications"
                formik={formik}
                required={true}
                readOnly={applicationFilteredList?.length < 0 ? true : false}
                // readOnly={applicationFilteredList?.length === 0}  // Corrected condition
                options={applicationFilteredList?.length > 0 ?  applicationFilteredList?.map((obj)=>{
                  return {
                    label : obj?.title,
                    value : obj?._id
                  };
                }) :[]}
                type="select"
                placeholder="Select"
                value={formik.values.applicationId}
                onChange={handleApplication}
              />
            </Col>
            <Col lg={4}>
              <TextInput
                keyField={"taskAction"}
                label="Task Action"
                options={taskActionOptions}
                type="select"
                formik={formik}
                required={true}
                placeholder="Select"
                value={formik.values.taskAction}
                onChange={(e) => {
                  formik.setFieldValue("taskAction", e.target.value);
                }}
              />
            </Col>

            {isDocumentListVisible && selectedApplication?.applicationDocuments?.length > 0 && (
            <Col xs={12} sm={6} lg={4} className="sapacing-two">
              <TextInput
                keyField={"documentId"}
                label="Document"
                options={selectedApplication.applicationDocuments?.map((obj) => {
                  return {
                    label: obj?.title || 'Unknown',
                    value: obj?._id
                  };
                })}
                type="select"
                formik={formik}
                required={true}
                placeholder="Select"
                value={formik.values.documentId}
                onChange={(e) => {
                  formik.setFieldValue("documentId", e.target.value);
                }}
              />
            </Col>
          )}

            {isFormListVisible && selectedApplication?.applicationForms?.length > 0 && (
              <Col xs={12} sm={6} lg={4} className="">
                <TextInput
                  keyField={"formId"}
                  label="Form"
                  options={selectedFormOptions} // Dynamically selected options
                  type="select"
                  required={true}
                  formik={formik}
                  placeholder="Select"
                  value={formik.values.formId}
                  onChange={(e) => {
                    formik.setFieldValue("formId", e.target.value);
                  }}
                />
              </Col>
            )}
          <Col lg={4}>
              <TextInput
                  keyField="assignee"
                  required
                  label="Assign To"
                  formik={formik}
                  options={assignToOptions}
                  type="select"
                  placeholder="Select"
                  value={formik.values.assignee}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (!formik.values.patientId) {
                      failed("Please select patient first");
                      return;
                    }
                    formik.setFieldValue("assignee", value);
                    // Ensure `assignTo` is null when "Patient" is selected
                    if (value === "Patient") {
                      formik.setFieldValue("assignTo", null);
                    }
                  }}
                />
            </Col>
            <Col lg={4}>
              {formik.values.assignee === "Staff" && <TextInput
                keyField={"assignTo"}
                label="Select User"
                formik={formik}
                required={true}
                // readOnly={applicationFilteredList?.length < 0 ? true : false}
                options={assignToList}
                type="select"
                placeholder="Select"
                value={formik.values.assignTo}
                onChange={(e)=> formik.setFieldValue("assignTo", e.target.value)}
              />}
            </Col>
            <Col lg={4} className="modal_pro_file">
              <DatePickerSelector
                keyField={"dueDate"}
                formik={formik}
                required={false}
                value={formik.values.dueDate}
                minDate={moment()}
                maxDate={""}
                label="Due Date"
                type="date"
                onChange={(e) =>
                  formik.setFieldValue("dueDate", moment(e).format("MM-DD-YYYY"))
                }
              />
            </Col>
            <Col lg={12}>
                <TextInput
                  keyField={"notes"}
                  label="Notes"
                  formik={formik}
                  required={false}
                  type="text"
                  value={formik.values.notes}
                  onChange={(e) => formik.setFieldValue("notes", e.target.value)}
                />
              </Col>
          </Row>
          <div className="d-flex gap-4 justify-content-center">
            <Button className="primary">Save</Button>
            <Button className="secondary" onClick={setOpenTaskForm}>Close</Button>
          </div>
        </Form>
      </div>
    </Fragment>
  );
};

export default Tasks;
